/* registerIcons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("form.launch", require("./rawicons/launch.icon.svg.js"));
IconRegistry.registerIcon("form.edit", require("./rawicons/edit.icon.svg.js"));
IconRegistry.registerIcon("form.read_only", require("./rawicons/read_only.icon.svg.js"));
IconRegistry.registerIcon("form.no_multi_edit", require("./rawicons/no_multi_edit.icon.svg"));
IconRegistry.registerIcon("form.expand_collapse", require("./rawicons/expand_collapse.icon.svg"));
